import { render, staticRenderFns } from "./targetpest.vue?vue&type=template&id=38080f7d&scoped=true&"
import script from "./targetpest.vue?vue&type=script&lang=js&"
export * from "./targetpest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38080f7d",
  null
  
)

export default component.exports